import { useState } from 'react'
import toast from 'react-hot-toast'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import { postProject } from '@/api'
import FormItem from '@/components/FormItem/FormItem'
import Input from '@/components/Input/Input'
import Popup from '@/components/Popup/Popup'
import PrimaryButton from '@/components/PrimaryButton/PrimaryButton'
import Textarea from '@/components/Textarea/Textarea'
import useActiveProjectIdActions from '@/hooks/useActiveProjectIdActions'
import { appReducerActions } from '@/store/reducers/app'

import './createProjectPopup.scss'

const CreateProjectPopup = ({ isVisible, handleClosePopup }) => {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  const [projectDetail, setProjectDetail] = useState({ name: '', apiBaseUrl: '', description: '' })

  const dispatch = useDispatch()
  const { handleSetActiveProjectId } = useActiveProjectIdActions()

  const isValidProjectDetail = projectDetail.name !== '' && projectDetail.apiBaseUrl !== ''

  const handleChangeProjectDetail = detail => setProjectDetail({ ...projectDetail, ...detail })

  const handleChangeInput = detailKey => e => handleChangeProjectDetail({ [detailKey]: e.target.value })

  const handleChangeClickCreateButton = async () => {
    try {
      setIsLoading(true)

      const projectRes = await postProject(projectDetail)
      const project = projectRes.data
      const projectId = project.id

      dispatch(
        appReducerActions.addProject({
          ...project,
          isAdmin: true,
        }),
      )
      handleSetActiveProjectId(projectId)

      handleClosePopup()
    } catch (err) {
      toast.error(t('createProject.error.general'))
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Popup title={t('createProject.title')} isVisible={isVisible} handleClosePopup={handleClosePopup}>
      <div className='create-project'>
        <div className='create-project__list'>
          <FormItem className='create-project__item' label={t('createProject.label.name')}>
            <Input className='create-project__input' value={projectDetail.name} onChange={handleChangeInput('name')} />
          </FormItem>
          <FormItem className='create-project__item' label={t('createProject.label.url')}>
            <Input className='create-project__input' value={projectDetail.apiBaseUrl} onChange={handleChangeInput('apiBaseUrl')} />
          </FormItem>
          <FormItem className='create-project__item' label={t('createProject.label.description')}>
            <Textarea className='create-project__input' value={projectDetail.description} onChange={handleChangeInput('description')} />
          </FormItem>
        </div>
        <PrimaryButton
          onClick={handleChangeClickCreateButton}
          isLoading={isLoading}
          disable={!isValidProjectDetail}
          className='create-project__create-btn'>
          {t('createProject.button.create')}
        </PrimaryButton>
      </div>
    </Popup>
  )
}

export default CreateProjectPopup
